import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Products from './pages/Products';
import Contact from './pages/Contact';
import './App.css';

import AICybersecurity from './posts/AI_Cybersecurity';
import NGINXWAFDevelopment from './posts/NGINX_WAF_Development';
import BuildingCloudRhino from './posts/Building_Cloud_Rhino';
import ThankYou from './pages/ThankYou';
import InfinityPlusDocs from './pages/InfinityPlusDocs';
import Footer from './components/Footer';

function App() {
  return (
    <div className="app-container">
      <Router>
        <div className="content-wrap">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Products />} />
            <Route path="/blog/ai-driven-cybersecurity-future" element={<AICybersecurity />} />
            <Route path="/blog/nginx-based-waf-development" element={<NGINXWAFDevelopment />} />
            <Route path="/blog/building-cloud-rhino" element={<BuildingCloudRhino />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/docs/infinityplus" element={<InfinityPlusDocs />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
